import { gql } from '@apollo/client';

export default gql`
  query getClientState {
    leftPanelWidth @client
    selectedPage @client
    sideMenu @client
    modalTypeShown @client
    numberOfColumns @client
    selectedPlanNodeId @client
    selectedSubContentIndex @client
    selectedIntroContentIndex @client
    pageType @client
    generalSettingsCurrentTab @client
    checked @client
    showPreviewLinks @client
    syncSelectAllDropdown @client
    sidebarMask @client
    deviceView @client
  }
`; 